export const UPDATE_NICK_NAME_REQUEST = 'UPDATE_NICK_NAME_REQUEST';
export const UPDATE_NICK_NAME_SUCCESS = 'UPDATE_NICK_NAME_SUCCESS';
export const UPDATE_NICK_NAME_FAIL = 'UPDATE_NICK_NAME_FAIL';

export const SET_LOCALE_REQUEST = 'SET_LOCALE_REQUEST';
export const SET_LOCALE_FAIL = 'SET_LOCALE_FAIL';

export const SET_USER_SCORES_SUCCESS = 'SET_USER_SCORES_SUCCESS';
export const SET_USER_SCORE_FAILED = 'SET_USER_SCORE_FAILED';

export const DO_LOGIN_REQUEST = 'DO_LOGIN_REQUEST';
export const DO_LOGIN_FAILED = 'DO_LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
